<template>
  <div class="list">
    <div>
      <div :class="{ list_item: true, br8: !showMoreStatus, br12: showMoreStatus }">
        <div class="item_top">
          <div class="station_cover-outer">
            <img class="station_cover" :src="dataDetail.picurl" />
          </div>
          <div class="top_content">
            <div class="top_title">
              <span class="limit1">{{ dataDetail.name }}</span>
            </div>
            <div class="top_road">
              <span class="limit1">{{ dataDetail.roadname }}</span>
            </div>

            <div class="top_desc">{{ dataDetail.address }}</div>
          </div>

          <div class=" top_position">
            <div v-if="showMoreStatus" @click="toStaDetial" class="readMore">
              查看详情
              <img style="width: 0.1rem;height: .1rem;" src="~@/assets/img/arrow_right.png" />
            </div>
            <div v-else style="height: .06rem;"></div>
            <div style="float: right;margin-right: .01rem;" @click="
              daohang(
                dataDetail.name,
                dataDetail.longitude || dataDetail.coor_x,
                dataDetail.latitude || dataDetail.coor_y
              )">
              <img class="map" src="~@/assets/img/map.png" />
              <div class="top_distance">
                {{ (Number(dataDetail.distance) / 1000).toFixed(1) }}km
              </div>
            </div>

          </div>
        </div>
        <div class="item_bottom">
          <div class="bottom_ru">
            <div class="bottom_left">
              <img src="~@/assets/img/enter.png" />入口
            </div>
            <div class="bottom_right">
              <div>
                <div class="bottom_name">往{{ dataDetail.direction1 }}方向</div>
                <div @click="
                  dataDetail.control1 == '限行车型'
                    ? showMsg(dataDetail.poiid, 'cartype')
                    : ''
                  " :class="`bottom_status ${getStationStatus(dataDetail.control1)}`">
                  {{ dataDetail.control1 }}
                  <img v-if="dataDetail.control1 == '限行车型'" src="~@/assets/img/warning.png" />
                </div>
              </div>
              <div>
                <div class="bottom_name">往{{ dataDetail.direction2 }}方向</div>
                <div @click="
                  dataDetail.control2 == '限行车型'
                    ? showMsg(dataDetail.poiid, 'cartype2')
                    : ''
                  " :class="`bottom_status ${getStationStatus(dataDetail.control2)}`">
                  {{ dataDetail.control2 }}
                  <img v-if="dataDetail.control2 == '限行车型'" src="~@/assets/img/warning.png" />
                </div>
              </div>
            </div>
          </div>
          <div v-if="dataDetail.crossControlDesc" class="tips">
            <div>
              <img class="tip_icon" src="@/assets/img/tips.png" />
              <div class="tip_content">{{ dataDetail.crossControlDesc }}</div>
            </div>
            <div>
              <div @click="showMore(dataDetail.crossControlDesc)" class="tip_more">更多</div>
              <img class="tip_arrow" src="@/assets/img/ar.png" />
            </div>
          </div>
          <div v-else class="line"></div>

          <div class="bottom_chu">
            <div class="bottom_left">
              <img src="~@/assets/img/exit.png" />出口
            </div>
            <div class="bottom_right">
              <div>
                <div class="bottom_name">{{ dataDetail.direction1 }}方向</div>
                <div @click="dataDetail.control3 == '限行车型' ? showMsg(dataDetail.poiid, 'cartype3') : ''"
                  :class="`bottom_status ${getStationStatus(dataDetail.control3)}`">{{ dataDetail.control3
                  }}
                  <img v-if="dataDetail.control3 == '限行车型'" src="~@/assets/img/warning.png" />
                </div>
              </div>
              <div>
                <div class="bottom_name">{{ dataDetail.direction2 }}方向</div>
                <div @click="dataDetail.control4 == '限行车型' ? showMsg(dataDetail.poiid, 'cartype4') : ''"
                  :class="`bottom_status ${getStationStatus(dataDetail.control4)}`">{{ dataDetail.control4
                  }}
                  <img v-if="dataDetail.control4 == '限行车型'" src="~@/assets/img/warning.png" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div ref="dialog" v-show="showDialog" class="mask">
      <div class="msgbox">
        <div class="msg_title">温馨提示</div>
        <div class="msg_content">限行车型：{{ msg }}</div>
        <div @click="showDialog = false" class="msg_btn">确定</div>
      </div>
    </div>

    <div v-if="showToast" class="toast_main">
      <div class="toast">
        <div v-html="toastMsg"></div>
      </div>
    </div>
    <msgBox ref="msgBox" />
  </div>
</template>
<script>
import getLocations from "@/assets/js/getLocation"
import msgBox from './msgBox.vue'
export default {
  components: { msgBox },
  props: {
    dataDetail: {
      type: Object,
      default: {}
    },
    showMoreStatus: {
      type: Boolean,
      default: false
    },
    ticketid: '',
  },
  data() {
    return {
      showToast: false,
      toastMsg: '',
      showDialog: false,
      msg: '',
    }
  },
  watch: {
    showDialog(val) {
      if (val) {
        document.querySelector('body').classList.add('no-scroll')
      } else {
        document.querySelector('body').classList.remove('no-scroll')
      }
    }
  },
  computed: {
    getStationStatus() {
      return function (status) {
        switch (status) {
          case '正常':
            return "green"
          case '关闭':
            return "red"
          case '管制':
            return "orange"
          case '限行车型':
            return "orange"
          default:
            return "black"
        }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      document.body.appendChild(this.$refs.dialog);
    })
  },
  methods: {
    showMore(msg) {
      this.$refs.msgBox.open(msg);
    },
    toStaDetial() {
      this.$emit('toStaDetial')
    },
    daohang(title, lng, lat) {
      try {
        this.handler('introductionDetailNavi', { lng: Number(lng), lat: Number(lat), title: title })
      } catch (e) {
        //微信小程序环境
        if (window.__wxjs_environment === 'miniprogram') {
          getLocations(title, lng, lat)
        } else {
          //微信环境
          var gaodeLoc = [lng, lat]
          var marker = new AMap.Marker({
            position: gaodeLoc
          })
          marker.markOnAMAP({
            position: marker.getPosition(),
            name: title
          })
        }
      }
    },
    addToast(toastMsg) {
      this.showToast = true
      this.toastMsg = toastMsg
      let timer = setTimeout(() => {
        this.showToast = false
        clearTimeout(timer)
      }, 2000)
    },
    showMsg(poiid, type) {
      this.$Post(
        "highwayInfoDetail/fetchControlInfo",
        {
          poiid: poiid
        },
        ({ data = {} }) => {
          this.msg = data.control[type]
          this.showDialog = true
        },
        err => {
          this.$alertShow(err.msg)
        },
        true
      )
    },
    handler(method, params) {
      if (/android/i.test(navigator.userAgent)) {
        let android = window.liaoningactivity || window.uroadhtml
        try {
          params ? android[method](...Object.values(params)) : android[method]()
        } catch (e) {
          console.log('android调用失败：' + method + e)
          throw new Error('android调用失败：' + method + e)
        }
      } else if (/ios|mac|iphone|ipod|pad/i.test(navigator.userAgent)) {
        if (method == 'uroadplus_loginNew') method = 'uroadplus_login_ticket'
        params = params ? params : {}
        try {
          window.webkit.messageHandlers[method].postMessage(params)
        } catch (e) {
          console.log('ios调用失败：' + method + e)
          throw new Error('android调用失败：' + method + e)
        }
      }
    },
  }
}
</script>
<style lang="less" scoped>
.tips {
  margin: .11rem -.14rem .11rem -.24rem;
  padding: 0 .13rem;
  height: 0.33rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(270deg, #FFF8F9 0%, #FFEEF1 100%);
  box-shadow: 0rem 0.02rem 0.11rem 0rem rgba(238, 238, 238, 0.5);
  font-size: 0.12rem;
  color: #E3001C;
  text-align: left;
  font-style: normal;
  font-weight: normal;

  >div {
    display: flex;
    align-items: center;
  }

  .tip_icon {
    width: .14rem;
    height: .14rem;
  }

  .tip_content {
    width: 2.64rem;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    margin: 0 0 0 .04rem;
  }

  .tip_arrow {
    width: 0.04rem;
    height: 0.07rem;
  }

  .tip_more {
    margin-right: .03rem;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.11rem;
    color: #666666;
  }
}

.toast_main {
  position: fixed;
  z-index: 99999;
  width: 100%;
  height: 100vh;
  left: 0;
  top: 0;

  .toast {
    z-index: 99999;
    position: fixed;
    bottom: 0.91rem;
    left: 0.42rem;
    width: 2.9rem;
    background: rgba(0, 0, 0, 0.71);
    font-size: 0.16rem;
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 400;
    color: #ffffff;
    line-height: 0.26rem;
    padding: 0.15rem 0.05rem;
    border-radius: 0.12rem;
    text-align: center;
  }
}

.list_loading {
  font-size: 0.13rem;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #9d9fa8;
  line-height: 0.2rem;
  // padding: .1rem 0;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.list_loading::before {
  content: "";
  display: block;
  width: 0.34rem;
  height: 0.01rem;
  background: #bebebe;
  margin-right: 0.13rem;
}

.list_loading::after {
  content: "";
  display: block;
  width: 0.34rem;
  height: 0.01rem;
  background: #bebebe;
  margin-left: 0.13rem;
}

.mask {
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.74);
  width: 100%;
  height: 100%;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;

  .msgbox {
    width: 3.2rem;
    background: #ffffff;
    border-radius: 0.12rem;
    padding: 0.26rem 0.35rem;
    box-sizing: border-box;
    text-align: center;

    .msg_title {
      font-size: 0.18rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #000000;
      line-height: 0.25rem;
    }

    .msg_content {
      font-size: 0.16rem;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #333333;
      line-height: 0.26rem;
      margin-top: 0.14rem;
    }

    .msg_btn {
      margin-top: 0.18rem;
      width: 2.5rem;
      height: 0.44rem;
      line-height: 0.44rem;
      background: #0081f6;
      border-radius: 0.07rem;
      font-size: 0.16rem;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #ffffff;
    }
  }
}

.empty {
  padding: 1.18rem 0;
  margin: 0 0.51rem;
  font-size: 0.14rem;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #666666;
  line-height: 0.21rem;
  text-align: center;

  img {
    width: 100%;
    margin-bottom: 0.03rem;
  }
}

.list_item:last-of-type {
  margin-bottom: 0;
}

.br8 {
  border-radius: 0.08rem;
}

.br12 {
  border-radius: 0.12rem 0.12rem 0rem 0rem;
}

.list_item {
  margin-bottom: 0.1rem;
  width: 100%;
  background: #ffffff;
  box-shadow: 0rem 0.02rem 0.11rem 0rem rgba(238, 238, 238, 0.5);
  // border: 0.01rem solid #f3f3f3;
  padding: 0.16rem .14rem 0.15rem 0.12rem;
  box-sizing: border-box;

  .item_top {
    display: flex;

    .station_cover-outer {
      position: relative;
      font-size: 0;

      .station_cover {
        width: 0.53rem;
        height: 0.53rem;
        object-fit: cover;
        border-radius: 0.1rem;
      }

      .jiaobiao {
        width: 0.27rem;
        height: 0.27rem;
        position: absolute;
        top: -0.03rem;
        right: -0.04rem;
      }
    }

    .top_content {
      margin-left: 0.06rem;
      width: 1.86rem;

      .top_title {
        font-size: 0.16rem;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
       
        color: #333333;
        // line-height: 0.24rem;
        margin-top: -0.03rem;
        display: flex;
        align-items: center;

        .limit1 {
          font-weight: bold;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        img {
          margin-left: 0.1rem;
          width: 0.18rem;
          // height: 0.17rem;
        }

        .favorite_desc {
          word-break: keep-all;
          color: #999999;
          font-size: 0.12rem;
          font-weight: normal;
          margin-left: 0.03rem;
        }
      }

      .top_road {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 0.12rem;
        color: #666666;
        text-align: left;
        font-style: normal;
        margin-top: .08rem;
      }

      .top_desc {
        font-size: 0.14rem;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #555868;
        margin-top: 0.08rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .top_position {
      // margin-left: .21rem;
      text-align: center;
      width: 0.54rem;
      text-align: center;
      flex: 1;

      .readMore {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 0.12rem;
        color: #999999;
        text-align: right;
        font-style: normal;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-top: -.06rem;
      }

      .map {
        margin-top: 0.1rem;
        width: 0.18rem;
        height: 0.18rem;
        float: right;
        margin-right: .07rem;
      }

      .top_distance {
        margin-top: .33rem;
        font-size: 0.11rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 0.16rem;
      }
    }
  }

  .item_bottom {
    margin-top: 0.16rem;
    padding-left: 0.12rem;
    box-sizing: border-box;

    .bottom_ru,
    .bottom_chu {
      display: flex;
    }

    .bottom_left {
      margin-top: 0.14rem;
      display: flex;
      align-items: center;
      flex: 0 0 0.74rem;
      width: 0.74rem;
      height: 0.2rem;
      border-right: 0.01rem solid #e5e5e5;

      font-size: 0.16rem;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #40444c;
      line-height: 0.2rem;

      img {
        width: 0.2rem;
        height: 0.2rem;
        margin-right: 0.03rem;
      }
    }

    .line {
      margin: 0.12rem 0 0.11rem 0.94rem;
      width: 2.04rem;
      height: 1px;
      background: #e5e5e5;
    }

    .bottom_right {
      margin-left: .1rem;
      flex: 1;
      // padding: 0 .23rem 0 .13rem;
      box-sizing: border-box;
      display: flex;
      text-align: center;

      div {
        flex: 1;
      }

      .bottom_name {
        font-size: 0.14rem;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        // font-weight: bold;
        color: #333333;
      }

      .bottom_status {
        margin-top: 0.09rem;
        font-size: 0.15rem;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .green {
        color: #46ae65;
      }

      .orange {
        color: #f47920;

        img {
          width: 0.15rem;
          height: 0.15rem;
          margin-left: 0.01rem;
        }
      }

      .black {
        color: #333333;
      }

      .red {
        color: #f02600;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/components/tollStationDetail1.vue